import { useEffect, useLayoutEffect, useState } from 'react';

// Measuring before paint keeps the control from shifting once it is visible, but
// the server has no layout to read, and `useLayoutEffect` warns when it runs there.
const useBeforePaintEffect = process.env.JS_ENV_CLIENT ? useLayoutEffect : useEffect;

const measure = (): number => {
  const probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow-y:scroll';
  document.body.appendChild(probe);
  const width = probe.offsetWidth - probe.clientWidth;
  probe.remove();

  return width;
};

/**
 * The layout space a classic scrollbar track takes, so a fixed element can be
 * offset past one. Zero before layout, and where scrollbars overlay the content.
 */
const useScrollbarTrackWidth = (): number => {
  const [width, setWidth] = useState(0);

  useBeforePaintEffect(() => {
    const remeasure = (): void => setWidth(measure());

    remeasure();

    // Browser zoom changes the track's width in CSS pixels and fires a resize.
    window.addEventListener('resize', remeasure);
    return () => window.removeEventListener('resize', remeasure);
  }, []);

  return width;
};

export default useScrollbarTrackWidth;
